import _get from 'lodash/get';
import _set from 'lodash/set';
import pageMeta from 'pageMeta/pageMeta';
import { get as cookiesGet } from 'bam-cookies/dist/browser_browser_es5/main';

class DfpConfigUtil {

    /**
     *
     * @desc Define DFP params to be sent through bam video paid interruptions
     * @returns {object} DFP parameters
     *
     */
    static getDfpParams(config) {

        var ppid = DfpConfigUtil.getPpid();
        var isEu = _get(config, 'isEu', false);
        var npa = DfpConfigUtil.getNpa(isEu);
        //im doing this again BC the cust params are not passed to this function, and to change that we need changes in paid-interruptions
        var booststrapData = window.dataBootstrap;
        var env = pageMeta['env'];


        var mapper = {
            /** Required DFP Parameters */
            iu: _get(config, 'iu'),
            description_url: _get(config, 'description_url', '[description_url]'),
            env: _get(config, 'env', 'vp'),
            correlator:  _get(config, 'correlator', '[timestamp]'),
            gdfp_req: _get(config, 'gdfp_req', '1'),
            output: _get(config, 'output', 'vmap'),
            sz: _get(config, 'sz', '640x480'),
            unviewed_position_start: _get(config, 'unviewed_position_start', '1'),
            url: _get(config, 'url', '[referrer_url]'),
            cmsid: _get(config, 'cmsid', null),
            /** Optional DFP Parameters */
            ad_rule: _get(config, 'ad_rule', '1'),
            pp: _get(config, 'pp', 'mlb_csai_vod_desktop'),
            ciu_szs: _get(config, 'ciu_szs', '300x100'),

        };

        if (ppid) {

            _set(mapper, 'ppid', ppid);

        }

        if (npa !== undefined) {

            _set(mapper, 'npa', npa);

        }

        if (env) {

            mapper.iu = mapper.iu.replace('{env}', env === 'qa' || env === 'local' ? 'qa_' : '');

        }


        return mapper;

    }

    /**
     *
     * @desc retrieve the ppid value
     * @todo hash the returned value
     * @todo replace hashed ipid with hased okta token
     *
     */
    static getPpid() {

        return cookiesGet('ipid');

    }

    /**
     *
     * @desc determines the value for npa based on TrueArc opt and if the user its in the EU
     * Checks for the existance of the `notice_gdpr_prefs` cookie
     * If it doesn't exist npa is set to 1 (user opted out of personalized ads)
     * If the user its not in the EU value its set to zero
     * If the user is in the EU, the cookie exists and it's contains the value "2",  npa is set to 1 (user opted in to personalized ads)
     * If the user is in the EU, the cookie exists and it doesn't contain the value "2", npa is set to 0 (user opted out of personalized ads)
     * REF: https://wiki.mlbam.com/display/adopstrafficking/Web+-+Ad+Manager+CSAI+Ad+Tag+Parameters
     *
     */
    static getNpa(isEu) {

        var noticeGdprPrefs = cookiesGet('notice_gdpr_prefs') || '';

        return (isEu && noticeGdprPrefs.indexOf('2') === -1) ? '1' : '0';

    }

}

export default DfpConfigUtil;
